module.exports = __webpack_public_path__ + "static/media/BiondinaRefil.1f156153.png";